<template>
    <div class="lo page">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .lo.page {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        flex-shrink: 0;
        padding: $interval-l 50px;
        padding-top: 0;
        max-width: $pc-width;
        margin: 0 auto;
        margin-top: 60px;

        > div:only-child {
            flex: 1;
        }

        @include media('mobile') {
            flex-direction: column;
            padding: $interval-m;
        }
    }
</style>
